import {Component, OnInit} from '@angular/core';


@Component({
    selector: 'burncase-authentication-view',
    templateUrl: './authentication-view.component.html',
    styleUrls: ['./authentication-view.component.css']
})
export class AuthenticationViewComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {

    }

}
